import SideNavigation from '../Common/sideNavigation';
import ProjectApprovalTable from './projectApprovalTable';

/**
 * Returns the Project Approval page component.
 * 
 * @returns Project Approval page component.
 */
export default function ProjectApproval() {

  return (
    <>
      <div className="flex flex-col h-fit md:h-screen">
        <div className="h-full bg-gray-50">
          <SideNavigation />

          <main className="lg:pl-72 bg-gray-50 h-full">

              <ProjectApprovalTable/>
                
          </main>

        </div>
      </div>
    </>
  );
};